// Documentation is located https://github.com/kidjp85/react-id-swiper/tree/1.6.4

import React, { Component } from 'react';
import Swiper from 'react-id-swiper';

const icons = [
  {
    sector_name: 'Manufacturing',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021//mobile-header/fcmic-icon-01manufacturing.png',
    top: 115,
    left: 72
  },
  {
    sector_name: 'Travel',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021//mobile-header/fcmic-icon-02travel.png',
    top: 116,
    left: 50
  },
  {
    sector_name: 'Music',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021//mobile-header/fcmic-icon-03music.png',
    top: 116,
    left: 50
  },
  {
    sector_name: 'Corporate Responsibility',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021//mobile-header/fcmic-icon-04corp-responsibility.png',
    top: 114,
    left: 70
  },
  {
    sector_name: 'Workplace',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021//mobile-header/fcmic-icon-05workplace.png',
    top: 125,
    left: 50
  }
];

class MicMobileIconCarousel extends Component {
  constructor(props) {
    super(props);
    this.swiperResize = this.swiperResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.swiperResize);
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    }, 400);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.swiperResize);
  }

  swiperResize() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  render() {
    const settings = {
      navigation: {
        nextEl: '.carousel-next-btn-mobile',
        prevEl: '.carousel-prev-btn-mobile'
      },
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 750,
        disableOnInteraction: false
      },
      renderPrevButton: () => <button className="carousel-prev-btn-mobile" />,
      renderNextButton: () => <button className="carousel-next-btn-mobile" />
    };

    return (
      <div>
        <Swiper
          {...settings}
          ref={node => {
            if (node) this.swiper = node.swiper;
          }}
        >
          {icons.map((item, index) => (
            <article key={`${index}`} style={{ padding: 10 }}>
              <div className="mobile-icon-container">
                <img
                  className="mobile-icon-img"
                  src={item.sector_image}
                  alt={item.sector_name}
                />
              </div>
            </article>
          ))}
        </Swiper>
      </div>
    );
  }
}

export default MicMobileIconCarousel;
